import TravelerTripsContainer from './trips-container';

export default TravelerTripsContainer;
